import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Typography, Button, CssBaseline } from '@mui/material';
import { HomeRounded } from '@mui/icons-material';

const NotFound = () => {
  return (
    <>
      <CssBaseline />
      <Box
        sx={{
          height: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: 'background.default',
        }}
      >
        <Box
          sx={{
            bgcolor: 'background.paper',
            border: 1,
            borderColor: 'divider',
            borderRadius: 2,
            p: { xs: 4, md: 6 },
            flex: '0 1 600px',
            textAlign: 'center',
          }}
        >
          <Typography variant="h1" fontWeight={800} color="primary" sx={{ mb: 1 }}>
            404
          </Typography>
          <Typography variant="h5" fontWeight={600} sx={{ mb: 2 }}>
            الصفحة غير موجودة
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
            عذراً، الصفحة التي تحاول الوصول إليها غير موجودة.
          </Typography>
          <Button
            component={Link}
            to="/"
            variant="contained"
            size="large"
            startIcon={<HomeRounded />}
            sx={{ textTransform: 'none' }}
          >
            العودة إلى الصفحة الرئيسية
          </Button>
        </Box>
      </Box>
    </>
  );
};

export default NotFound;
